<template>
	<!-- 关联达人 -->
	<div class="drContactsCell flex-row-align-center" :key="row.id">
		<el-select
			class="select-search"
			v-model="anchorId"
			:loading-text="loading_danRen"
			clearable
			:popper-append-to-body="false"
			:loading="loading_Dren_icon"
			filterable
			@change="change"
			remote
			ref="template"
			:remote-method="remoteMethod_daRen"
			@visible-change="v => visibleChange(v, 'template')"
			@focus="focusFun_dRen"
			placeholder="请选择 / 搜索达人"
		>
			<el-option v-for="(item, index) in darenOptions" :key="index" :value="+item.anchor_id" :label="item.anchor_name" class="footer-option">
				<div class="dr-list">
					<div class="flex flex-align-center dr-list-li">
						<div class="footer-img mr-8">
							<img :src="item.head ? item.head : imgUrl" alt="" />
						</div>
						<div class="flex-column flex-just-start">
							<div class="flex flex-align-center">
								<rd-text class="yx-color-pure-1">{{ item.anchor_name | formatEmpty }}</rd-text>
								<div class="fans-label fz-12 flex flex-align-center ml-4">粉丝{{ item.fans_num }}</div>
							</div>
							<p class="douyin font-h4-regular">{{ platformId | formatPlatformName('unify') }}：{{ item.anchor_account }}</p>
						</div>
					</div>
				</div>
			</el-option>
		</el-select>
		<add-talent-drawer ref="addTalentDrawer" :platformId="platformId" @getDr="focusFun_dRen" @onInject="onInject" />
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { getTeamSeaList } from '@/api/talentCRM';
import { getInstitutionAnchorList } from '@/api/secondColonelManage';
import addTalentDrawer from '@/components/business/addTalentDrawer/addTalentDrawer.vue';
export default {
	name: 'drContactsCell',
	mixins: [mixin],
	watch: {
		'row.anchor_name': {
			handler(to) {
				this.anchorId = to;
			},
		},
	},
	data() {
		return {
			anchorId: '',
			loading_danRen: '加载中',
			loading_Dren_icon: false,
			form: {
				selectDare: '',
			},
			imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
			danRenObj: {},
			is_select_cont: true,
			darenOptions: [],
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
			selectType: 'account_name',
		};
	},
	components: {
		addTalentDrawer,
	},
	computed: {
		teamInstitutionId() {
			return this.row.team_institution_id;
		},
		platformId() {
			return this.row.platformId;
		},
	},
	methods: {
		visibleChange(visible, refName) {
			if (visible) {
				const ref = this.$refs[refName];
				let popper = ref.$refs.popper;
				if (popper.$el) popper = popper.$el;
				if (!Array.from(popper.children).some(v => v.className === 'el-template-menu__list') && this.$isDy(this.platformId)) {
					const el = document.createElement('ul');
					el.className = 'el-template-menu__list';
					el.style = 'padding:0; color:rgb(64 158 255);font-size: 13px';
					el.innerHTML = `<li class="el-cascader-node text-center" style="height:37px;line-height: 50px">
                        <span class="yx-color-primary"><i class="font-blue el-icon-plus mr-4"></i>新增关联达人</span>
                        </li>`;
					popper.appendChild(el);
					el.onclick = () => {
						this.showTalentDraw();
					};
				}
			}
		},
		//远程搜索
		async remoteMethod_daRen(e) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { teamInstitutionId, pageInfo } = this;
			// 视频号 暂时不用管管 只会有抖音快手 走到这里
			const { code, data } = this.$isDy(this.platformId)
				? await getInstitutionAnchorList({ ...pageInfo, team_institution_id: teamInstitutionId, anchor_name: e })
				: await getTeamSeaList({ ...pageInfo, anchor_name: e, platform_id: +dataMap.PLATFORM_KS.value });
			this.loading_Dren_icon = false;
			if (code == 0) {
				this.darenOptions = data.list;
			}
		},
		async focusFun_dRen(account, value) {
			this.loading_Dren_icon = true;
			this.loading_danRen = '加载中';
			const { teamInstitutionId, pageInfo } = this;
			// 视频号 暂时不用管管 只会有抖音快手 走到这里
			const { code, data } = this.$isDy(this.platformId)
				? await getInstitutionAnchorList({
						...pageInfo,
						team_institution_id: teamInstitutionId,
						anchor_name: '',
				  })
				: await getTeamSeaList({ ...pageInfo, anchor_name: '', platform_id: +dataMap.PLATFORM_KS.value });
			if (code == 0) {
				this.darenOptions = data.list;
				if (value) {
					let obj = this.darenOptions.find(v => v.anchor_account == account) || {};
					this.row.anchor_id = obj.anchor_id;
					this.row.anchor_name = obj.anchor_name;
				}
				data.list.length ? (this.loading_Dren_icon = false) : (this.loading_danRen = '无数据');
			}
		},
		// 新增关联达人
		showTalentDraw() {
			this.$refs.addTalentDrawer.show(this.teamInstitutionId, this.platformId);
		},
		change(e) {
			this.row.anchor_id = e;
			this.row.anchor_name = this.darenOptions?.find(v => v.anchor_id === e)?.anchor_name || '';
		},
		onChange() {
			this.anchorId = '';
			this.row.anchor_id = '';
			this.row.anchor_name = '';
		},
		onInject(param) {
			this.anchorId = param.anchorId;
		},
	},
};
</script>
<style lang="less" scoped>
.footer-img {
	img {
		width: 36px;
		height: 36px;
		border-radius: 50%;
	}
}
.douyin {
	margin-top: 2px;
	color: #86909d;
	font-size: 12px;
}
.fans-label {
	padding: 0 4px 0 4px;
	border-radius: 2px;
	background: #fff6f2;
	height: 18px;
	color: @color-warning;
}
/deep/.el-select-dropdown__item {
	height: 59px !important;
	line-height: 26px;
}
/deep/ .el-input__inner {
	font-size: 12px !important;
}
.select-search {
	width: 100%;
	/deep/ .el-input__inner {
		border-radius: 4px;
	}
}
.select-search {
	/deep/ .el-select-dropdown__item {
		padding: 0px;
		height: 100% !important;
	}
	/deep/ .el-select-dropdown {
		border-color: @color-gy3;
	}
}
.dr-list {
	border-bottom: 1px solid @color-gy3;
	.dr-list-li {
		padding: 8px 12px 8px 12px;
	}
}
/deep/ .el-select {
	.el-select__caret:first-child::before {
		content: '\e6e1';
	}
	.is-focus {
		.el-select__caret:first-child {
			transform: rotateZ(0deg);
		}
	}
}
</style>
